import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { conversionCartDetail } from 'lib/api/conversion';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const CartStatistics = () => {
  const { t } = useTranslation();
  const [initialization, setInitialization] = useState(false);
  const initParams = {
    pltfomTpCode: 'all',
    trackerFlag: 'all',
    sDate: moment().add(-8, 'day').format('YYYYMMDD'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    cartTpCode: '01,03',
    keyword: '',
  };

  const [params, setParams] = useState(initParams);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  // header �� body �÷� Ŀ����
  const customized = {
    PNM: {
      makeBody: (rowObj, headsMap) => {
        const pnm = getHeadObj(headsMap, 'PNM');
        return makeRowColumn(rowObj['PNM'], pnm.type, pnm.format);
      },
      bodyStyle: { maxWidth: 450 },
    },
  };

  const getTempParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      if (name === 'pageType') {
        if (newParams['cartTpCode'] === '01,03') {
          setParams({ ...newParams, cartTpCode: '02,04' });
        } else if (newParams['cartTpCode'] === '02,04') {
          setParams({ ...newParams, cartTpCode: '01,03' });
        }
      } else {
        setParams(newParams);
      }
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDisplayFilter
          useExternalFilter={false}
          useTracker={false}
        />
        <FilterCollection
          label={t('상세')}
          name="cartTpCode"
          params={params}
          type="radio"
          list={[
            { label: t('장바구니 상세'), value: '01,03' },
            { label: t('찜 상세'), value: '02,04' },
          ]}
          callBack={getTempParam}
          labelKey="label"
          valueKey="value"
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={conversionCartDetail}
        customized={customized}
        useTotal={false}
        useExcel={false}
      />
    </>
  );
};

export default CartStatistics;
